
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { Profile } from "@/types/profile";

export const usePublicProfile = (username: string, normalizedUsername: string) => {
  return useQuery<Profile | null>({
    queryKey: ["profile", normalizedUsername],
    queryFn: async () => {
      // Don't proceed if username is empty
      if (!username || !normalizedUsername) {
        return null;
      }

      console.log("Fetching profile:", normalizedUsername);
      const { data: normalizedData, error: normalizeError } = await supabase
        .rpc('normalize_username', { username });
      
      if (normalizeError) {
        console.error("Error normalizing username:", normalizeError);
        throw normalizeError;
      }

      const { data, error } = await supabase
        .from("profiles")
        .select(`
          *,
          recipes:recipes(*),
          packages:packages(*),
          reviews:reviews!reviews_creator_id_fkey(
            id,
            rating,
            comment,
            created_at,
            reviewer:profiles!reviews_reviewer_id_fkey(
              username,
              avatar_url
            )
          )
        `)
        .ilike('username', username)
        .maybeSingle();

      if (error) throw error;
      if (!data) return null;

      const profileNormalizedUsername = data.username.replace(/\s+/g, '').toLowerCase();
      return profileNormalizedUsername === normalizedUsername ? data as Profile : null;
    },
    enabled: !!username && !!normalizedUsername, // Only run query if username is provided
  });
};
